module.exports = new __parcel__URL__("../treeStatus_es.9f90465a.png").toString();